export const CATERING_PT_BR = {
	title: "Catering",
	description:
		"Listagem e configuração de itens usados nas propostas de serviços de Catering",
};

export type CateringTranslations = typeof CATERING_PT_BR;
